<template>
    <fragment>
        <div tabindex="0" class="project-item-status-info"
             @click="$emit('click')"
             @keypress.enter.space="$emit('click')"
             :aria-label="getAriaLabel()">
            <div class="project-item-status-info-type-step">
                <div class="project-item-status-step">
                    <span :class="{'name': true, 'd4d': project.type <= 1, 'ja-flows': project.type > 1}" v-if="isJAApp">{{ getProjectTypeName() }}</span>
                    <span class="step">Step {{ getStepForDisplay(project.lastStep) }} of {{getProjectLastPage(project.type)}}</span>
                </div>
                <div tabindex="0" v-if="showActions" class="project-item-status-actions">
                    <b-button variant="outline-primary" @click="onDelete" @keypress.enter.space="onDelete"  > <span class="icon icon-action" >  </span>  </b-button>
                    <b-button variant="outline-primary" @click="onSync" @keypress.enter.space="onSync"  v-if="isOnline && showActionSync" ><span class="icon icon-sync"> </span> </b-button>
                </div>
            </div>
            <div  class="project-item-status-info-name">{{project.name}}</div>
            <div v-if="project.lastUpdated"  class="project-item-status-info-date">
                Last Modified: {{ project.lastUpdated | shortDate }}
            </div>
        </div>

    </fragment>
</template>

<script>
    import {Steps} from "../../modules/D4D/Utils"
    import {Project} from '../../core/Utils'

    export default {
        name: "ProjectStatus",
        props:{
            project: {
                type: Object,
                required: true
            },
            index: {
                type: [Number, String],
                required: true
            },
            showActions:{
                type: Boolean,
                default: true
            },
            showActionSync:{
                type: Boolean,
                default: false
            },
        },
        methods: {
            getProjectLastPage(type){
                return Project.PROJECT_TOTAL_PAGE[type]
            },
            getStepForDisplay: Steps.getStepForDisplay,
            getProjectTypeName() {
                switch (this.project.type) {
                    case 0:
                        return Project.PROJECT_TYPE[Project.PROJECT_D4D]
                    case Project.PROJECT_D4D:
                    case Project.PROJECT_JOB_SHADOW:
                    case Project.PROJECT_BE_ENTREPRENEURIAL:
                        return Project.PROJECT_TYPE[this.project.type]
                }
                return ''
            },
            getAriaLabel() {
                let projectType = ''
                if (this.isJAApp) {
                    projectType = this.getProjectTypeName().replace('JA', 'J.A.')
                }
                return `
                    ${projectType}, project ${this.project.name}.
                    step ${this.getStepForDisplay(this.project.lastStep)} of 20.
                    last modified on ${this.project.lastUpdated ? this.$options.filters.shortDate(this.project.lastUpdated) : ''}.
                    `
            },
            onSync(){
                this.$emit('onSync', this.project, this.index)
            },
            onDelete(){
                this.$emit('onDelete', this.project, this.index)
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import "~@/core/Styles/variables.styl"
    .font-size
        .project-item-status
            &-actions
                width auto
        .project-item-status-info-name
            word-break break-all
        .project-item-status
            &-info
                &-type-step
                    .name
                        &.ja-flows
                            word-break break-all

    .project-item-status-info-name
        word-break break-word    
    .project-item-status
        &-info
            flex 1
            cursor pointer

            &-type-step
                font font-poppins-semibold
                font-size 11px
                display flex
                justify-content space-between
                .step
                    font-size inherit
                    color color-8
                .name
                    font-size inherit
                    padding-right 5px
                    &.d4d
                        color color-9

                    &.ja-flows
                        color color-27

            &-name
                font font-sourcesans-extrabold
                font-size 18px
                color color-black
                overflow-y auto
                max-height 200px
                padding-right: 8px

            &-date
                padding-top 11px
                font font-sourcesans-regular
                font-size 11px
                color color-4

        &-actions
            width 13%
            display flex
            justify-content: space-between;
            flex-direction: column;
            align-items flex-end
            .icon-action
                cursor pointer
                padding 0 5px
            .icon-sync
                width 36px

</style>
